import React, {useState, Fragment} from 'react';
import {Flex, Button, Breadcrumbs, Layout, Collaboration} from 'components';
import {flow, find, pick, modal, useNamedSelector, useRedirectToFirstCard} from 'helpers';
import {forbid} from 'store/session';

export function Dashboard({ match: { params: { id } } }) {
  const {premium} = useNamedSelector('session.subscription');
  const [ Tab, setTab ] = useState();
  const { byId } = useNamedSelector('collaborators.list');
  const getCollaboration = useNamedSelector('relations.getCollaboration');
  const user = byId[id];
  const relationExists = flow(
    getCollaboration,
    collaboration => find(collaboration?.relations, pick(user, 'email'))
  );
  useRedirectToFirstCard(null, !id);
  return (
    <Fragment>
      <Collaboration.DashboardSidebar />
      <main>
        { user &&
          <Fragment>
            <Layout.Header>
              <Flex className="justified">
                <div>
                  <h1 className="text-one-line">{user.email}</h1>
                  <Breadcrumbs className="small-spacing">
                    <span>Sharing Dashboard</span>
                    <span>Collaborator</span>
                  </Breadcrumbs>
                </div>
                <Button
                  className="primary"
                  icon="plus"
                  onClick={premium ? modal(Collaboration.SharePanelModal, { user, DefaultTab: Tab }) : forbid}
                  children="Share"
                />
              </Flex>
              <Collaboration.SharePanelTabs Tab={Tab} setTab={setTab} />
            </Layout.Header>
            { Tab && <Tab user={user} filter={relationExists} /> }
          </Fragment>
        }
      </main>
    </Fragment>
  );
}
